import { ApplicationConfig } from '@bybeam/platform-types';
import { COMMON_PAGES as CELL_ED_COMMON_PAGES } from '../calgrows/common.js';
import { COMMON_SECTIONS as CELL_ED_TRACK_2_COMMON_SECTIONS } from '../calgrows/learnAndEarn.js';

const CONFIG: ApplicationConfig = {
  introPages: [
    {
      key: 'what-is-it',
      layout: 'welcome',
      title: 'Welcome to the Westgate City workforce program',
      body: 'Westgate City gives caregivers of older adults and people with disabilities access to free training courses, career coaching and up to $6000 in incentives to help increase worker satisfaction and retention. Westgate city operates this program for in-home and community based caregivers.\n\nThrough this portal, qualified applicants can apply for Westgate City incentive payments.',
    },
    CELL_ED_COMMON_PAGES.whatToExpect,
    CELL_ED_COMMON_PAGES.applicationProcess,
  ],

  sections: CELL_ED_TRACK_2_COMMON_SECTIONS,
};
export default CONFIG;
